// @flow
import React from 'react'
import { TouchableOpacity, Text } from 'react-native'

type Props = {
  theme?: Object,
  label?: string,
  width?: string | number,
  height?: string | number,
  style?: Object,
  labelStyle?: Object,
  borderWidth?: number,
  borderRadius?: number,
  color?: string,
  borderColor?: string,
  onPress: Function,
}
const Button = ({
  theme,
  label,
  width,
  height,
  style,
  labelStyle,
  borderWidth,
  borderRadius,
  color,
  borderColor,
  onPress,
}: Props) => {
  const { palette, typography } = theme
  return (
    <TouchableOpacity
      onPress={onPress}
      style={{
        borderWidth: borderWidth !== undefined ? borderWidth : 1,
        borderRadius: borderRadius !== undefined ? borderRadius : 20,
        paddingVertical: 8,
        paddingHorizontal: 12,
        width: width || '100%',
        height,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: color || palette.background.default,
        borderColor: borderColor || palette.text.default,
        ...style,
      }}>
      <Text
        style={{
          fontSize: typography.actionFontSize,
          color: palette.text.default,
          ...labelStyle,
        }}>
        {label}
      </Text>
    </TouchableOpacity>
  )
}
export default Button
